import { INTERNAL_SHOWPASS_API_URL, API_URL, APP_ENV } from "@shared/env";

/*
  On beta and production deployments, dynamically set the baseURL for axios
  depending on whether this Repo is being initialized in a server environment
  or a client environment.
  This allows us to bypass DNS calls as our deployment are on a private network
*/

export function getBaseUrl(): string {
  return (APP_ENV === "beta" ||
    APP_ENV === "production" ||
    APP_ENV === "demo") &&
    typeof window === "undefined"
    ? INTERNAL_SHOWPASS_API_URL
    : API_URL;
}
